import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './screens/Landing';
import { SignIn } from './screens/SignIn';
import { Dashboard } from './screens/Dashboard';
import { CampaignDetail } from './screens/CampaignDetail';
import { SuggestionForm } from './screens/SuggestionForm';
import { CampaignForm } from './screens/CampaignForm';
import Demo from './screens/Demo';
import { Privacy } from './screens/Privacy';
import { PosterDemo } from './screens/PosterDemo';
import { PalmesusPoster } from './screens/PalmesusPoster';
import { useAppStore } from './store/appStore';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const currentAccount = useAppStore((state) => state.currentAccount);
  if (!currentAccount) return <Navigate to="/signin" replace />;
  return <>{children}</>;
};

export const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/campaign/:campaignId" element={
        <ProtectedRoute>
          <CampaignDetail />
        </ProtectedRoute>
      } />
      <Route path="/request/:handle" element={<SuggestionForm />} />
      <Route path="/request/:handle/:slug" element={<CampaignForm />} />
      <Route path="/requests/:handle" element={<SuggestionForm />} />
      <Route path="/poster/palmesus/:slug" element={<PalmesusPoster />} />
      <Route path="/poster/:slug" element={<PosterDemo />} />
      <Route path="/personvern" element={<Privacy />} />
      <Route path="/demo" element={<Demo />} />
    </Routes>
  );
};

export default App;
